var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNorway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagNorway_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagNorway_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagNorway_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagNorway_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagNorway_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC1C37",
    d: "M-2 44.116h70.484V3H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.42 44.116h10.276V3H13.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-2 28.698h70.484V18.421H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192967",
    d: "M15.986 44.116h5.139V3h-5.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192967",
    d: "M-2 26.13h70.484v-5.139H-2z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iM21nMG5vaHF1YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJrcXg1MmFjNDBiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzNtZzBub2hxdWEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiMzbWcwbm9ocXVhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgja3F4NTJhYzQwYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0RDMUMzNyIgZD0iTTAgNDEuMTE2TDcwLjQ4NCA0MS4xMTYgNzAuNDg0IDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgMykiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTUuNDIgNDEuMTE2TDI1LjY5NiA0MS4xMTYgMjUuNjk2IDAgMTUuNDIgMHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMjUuNjk4TDcwLjQ4NCAyNS42OTggNzAuNDg0IDE1LjQyMSAwIDE1LjQyMXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzE5Mjk2NyIgZD0iTTE3Ljk4NiA0MS4xMTZMMjMuMTI1IDQxLjExNiAyMy4xMjUgMCAxNy45ODYgMHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzE5Mjk2NyIgZD0iTTAgMjMuMTNMNzAuNDg0IDIzLjEzIDcwLjQ4NCAxNy45OTEgMCAxNy45OTF6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAzKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlagNorway as ReactComponent };